import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { deserializeSequence } from './serializer';

export const SEQUENCE_KEY = 'sequences';

export function getSequence(sequenceId?: string) {
  return request(`/sequences/${sequenceId}`, {
    method: 'GET',
  }).then(res => deserializeSequence(res));
}

export function useSequence(sequenceId?: string) {
  return useQuery({
    queryKey: [SEQUENCE_KEY, sequenceId],
    queryFn: () => getSequence(sequenceId),
    refetchOnWindowFocus: true,
    enabled: !!sequenceId,
  });
}
